module.exports = __webpack_public_path__ + "media/images/locked-badge-5f524689ad229044765fd1c95e05e3fb.png";